import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import axios from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { keycloak, initOptions, onKeycloakTokens, eventLogger} from './keycloak';
import { BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';


const root = ReactDOM.createRoot(document.getElementById('root'));

//If keycloak is off react will send the assigned dummpy username to the backend
if(process.env.REACT_APP_KEYCLOAK_USER){
  console.log("no keycloak")
  axios.post(`api/authUser`, {"User":process.env.REACT_APP_KEYCLOAK_USER}).then(res=>{
      console.log(res)
    })
}

 root.render(
  <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}
  //LoadingComponent={<p>Loading...</p>}
  onEvent={eventLogger}
    onTokens={onKeycloakTokens}>
    
    <BrowserRouter>
      {/* PrimeReact overlays (e.g. Dropdown) read their settings from this on scroll. */}
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </BrowserRouter>
  </ReactKeycloakProvider>
  );
 

//)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
